import request from '@/utils/request'

// 获取token
export function accountLogin(id, data) {
    return request({
        url: '/oauth/login/' + id,
        method: 'POST',
        data
    })
}

// 获取直播
export function accountChannel(id) {
    return request({
        url: '/teacher/channel/' + id,
        method: 'GET'
    })
}

// 禁言
export function forbiddenWords(id) {
    return request({
        url: '/teacher/banned/' + id + '/muted',
        method: 'GET'
    })
}
